import React, { useState } from 'react';
import FiltersModal from '../components/UsersFiltersModal';
import NewUserModal from './NewUserModalProps';
import { InputField } from '../../../components/ui/input-field';
import { Button } from '../../../components/ui/button';
import { Download, Plus, Filter } from 'lucide-react';
import { Search } from 'lucide-react';

const UsersHeader: React.FC = () => {
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [nuevoUserOpen, setNuevoUserOpen] = useState(false);

    return (
        <div className="flex items-center justify-between px-6 py-4">
            <span className="font-semibold text-2xl text-maxi-text-dark">Usuarios</span>
            <div className="relative flex-1 max-w-md">
                <InputField
                    label=""
                    name="search"
                    value={""}
                    onChange={() => { }}
                    placeholder="Buscar"
                    className="pl-10 mt-4 bg-background border-maxi-border"
                    icon={<Search className="w-6 h-6 text-[#BDBDBD] flex-shrink-0" />}
                />
            </div>
            <div className="flex items-center gap-3">
                <Button variant="default" className="gap-2 rounded-full">
                    <Download className="w-4 h-4" />
                    Exportar
                </Button>
                <Button variant="default" className="gap-2 rounded-full" onClick={() => setFiltersOpen(true)}>
                    <Filter className="w-4 h-4" />
                    Filtros
                </Button>
                <Button variant="default" className="gap-2 rounded-full" onClick={() => setNuevoUserOpen(true)}>
                    <Plus className="w-4 h-4" />
                    Nuevo Usuario
                </Button>
            </div>
            <FiltersModal open={filtersOpen} onClose={() => setFiltersOpen(false)} selectedStatus={""} setSelectedStatus={() => { }} statusOptions={[]} onClear={() => { }} onApply={() => { }} />
            <NewUserModal open={nuevoUserOpen} onClose={() => setNuevoUserOpen(false)} />
        </div>
    );
};

export default UsersHeader;
